import Hero from './Hero';
import { Helmet } from 'react-helmet-async';
import Features from './Features';
import HowItWorks from './HowItWorks';
import Web3Banner from './Web3Banner';
import FAQ from './FAQ';
import { useLang } from '../LangContext';

export default function Home() {
  const { t } = useLang();
  return (
	<>
		<Helmet>
			<html lang={t.langid} />
			<title>
			  {t.title}
			</title>

			<meta
			  name="description"
			  content={t.desc}
			/>
			
			<meta
			  name="keywords"
			  content={t.keywords}
			/>

      </Helmet>
      <Hero />
      <Features />
      <HowItWorks />
      <Web3Banner />
      <FAQ />
    </>
  );
}